import { Box, Typography, useMediaQuery } from '@mui/material';
import { Stat } from '../../services/type';
import { FC } from 'react';

interface Props {
    stat: Stat;
    raceFrom10: number;
    raceFrom25: number;
}

export const StatContent: FC<Props> = ({ stat }) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <Box display="flex" flexDirection="column" gap={isMobile ? 1 : 2} p={2}>
            <Box display={'flex'} flexDirection={'row'} gap={2}>
                <Typography variant="h6" color="primary" sx={{ width: "250px" }}>
                    Cote moyenne du podium :
                </Typography>
                <Box
                    display={'flex'}
                    justifyContent={'center'}
                    maxHeight={"27px"}
                    sx={{
                        border: '2px solid',
                        borderColor: 'primary.main',
                        p: 0.5,
                        width: '35px',
                        borderRadius: 2,
                    }}
                >
                    <Typography fontSize={18} fontWeight={600}>
                        {stat.averageOdd.toFixed(1)}
                    </Typography>
                </Box>
            </Box>
            <Box mt={1} display={'flex'} flexDirection={'column'}>
                <Typography variant="h6" color="primary">
                    Côtes sur le podium :
                </Typography>
                <Box mt={2} display={'flex'} flexDirection={'column'} width={"90%"} mx={'auto'} gap={2}>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap={1}
                    >
                        <Typography variant="h6" color="primary" sx={{ width: "180px" }}>
                            - inférieur à 10 :
                        </Typography>
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            maxHeight={"30px"}
                            sx={{
                                border: '2px solid',
                                borderColor: 'primary.main',
                                p: 0.5,
                                width: '35px',
                                borderRadius: 2,
                            }}
                        >
                            <Typography fontSize={18} fontWeight={600}>
                                {`${stat.percentages.under10.toFixed(0)}%`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap={1}
                    >
                        <Typography variant="h6" color="primary" sx={{ width: "180px" }}>
                            - entre 10 et 25 :
                        </Typography>
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            maxHeight={"30px"}
                            sx={{
                                border: '2px solid',
                                borderColor: 'primary.main',
                                p: 0.5,
                                width: '35px',
                                borderRadius: 2,
                            }}
                        >
                            <Typography fontSize={18} fontWeight={600}>
                                {`${stat.percentages.between10And25.toFixed(0)}%`}
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="row"
                        gap={1}
                    >
                        <Typography variant="h6" color="primary" sx={{ width: "180px" }}>
                            - supérieur à 25 :
                        </Typography>
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            maxHeight={"30px"}
                            sx={{
                                border: '2px solid',
                                borderColor: 'primary.main',
                                p: 0.5,
                                width: '35px',
                                borderRadius: 2,
                            }}
                        >
                            <Typography fontSize={18} fontWeight={600}>
                                {`${stat.percentages.above25.toFixed(0)}%`}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* Number of Pronos */}
            <Box mt={2}>
                <Typography variant="body1" color="text.secondary">
                    Nombre total de pronos analysés :<b>{stat.nbPronos}</b>
                </Typography>
            </Box>
        </Box>
    );
};
